<template>
  <v-card outlined class="pa-4 ma-0 d-flex flex-column" style="height: 390px">
    <!-- Header -->
    <v-container class="pa-0 pr-10 ma-0 d-flex flex-column gap-2 text-right rtl">
      <v-card-text class="pa-0 ma-0 text-body-1">
        {{ $t("productionDistribution") }}
      </v-card-text>
      <v-card-text class="pa-0 ma-0 text-body-2 gray--text" style="color: #717182">
        {{ $t("productionLineShare") }}
      </v-card-text>
    </v-container>
    <!-- donate chart -->
    <v-container class="pa-0 ma-0">
      <apexchart type="donut" height="190" :series="series" :options="chartOptions" />
    </v-container>
    <!-- details -->
    <v-container class="pa-0 ma-0">
      <v-list dense class="pa-0 ma-0">
        <v-list-item
          v-for="(item, index) in suppliers"
          :key="item.name"
          class="pa-0 ma-0"
        >
          <v-list-item-content>
            <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
              <v-container class="pa-0 ma-0 d-flex flex-column">
                <!-- title -->
                <v-container class="pa-0 ma-0 d-flex align-center">
                  <v-card-text
                    class="legend-dot pa-0 ma-0 ml-2"
                    :style="{ backgroundColor: colors[index] }"
                  >
                  </v-card-text>
                  <span class="body-2">
                    {{ item.name }}
                  </span>
                </v-container>
              </v-container>
              <v-container class="pa-0 ma-0 d-flex" style="width: auto">
                <v-card-text class="pa-0 ma-0 text-body-1">
                  {{ formatCurrency(item.amount) }}
                </v-card-text>
                <v-card-text class="pa-0 ma-0 text-body-2">%</v-card-text>
              </v-container>
            </v-container>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "donateProduction",
  data() {
    return {
      suppliers: [
        { name: "محصولات نهایی", amount: 45 },
        { name: "مواد اولیه", amount: 20 },
        { name: "کالای در راه", amount: 30 },
        { name: "قطعات", amount: 60 },
      ],
      colors: ["#3B82F6", "#10B981", "#F59E0B", "#8B5CF6", "#EF4444"],
    };
  },
  computed: {
    series() {
      return this.suppliers.map((i) => i.amount);
    },

    chartOptions() {
      return {
        chart: {
          type: "donut",
          fontFamily: "IRANSans",
        },

        labels: this.suppliers.map((i) => i.name),

        colors: this.colors,

        legend: {
          show: false,
        },

        stroke: {
          show: true,
          width: 0,
          colors: ["#ffffff"],
        },

        dataLabels: {
          enabled: false,
          style: {
            fontSize: "12px",
            colors: [],
          },
        },

        plotOptions: {
          pie: {
            donut: {
              size: "70%",
            },
          },
        },

        tooltip: {
          y: {
            formatter: (value) => `${value} م.ت`,
          },
        },
      };
    },
  },
  methods: {
    formatCurrency(value) {
      return value.toLocaleString("fa-IR");
    },
  },
};
</script>
<style scoped>
::v-deep .v-list--dense .v-list-item {
  min-height: 18px;
}
::v-deep .v-list-item__content {
  padding: 0px !important;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
</style>
